import React, { useState } from 'react';
import { 
  Home, 
  Building, 
  Users, 
  GraduationCap, 
  BarChart3, 
  Search, 
  Filter,
  ArrowLeft,
  ChevronDown,
  Download,
  Settings,
  User,
  BookOpen,
  Award,
  Clock
} from 'lucide-react';
import '../styles/SchoolTimetableManagement.css';

const SchoolTimetableManagement = ({ onBack }) => {
  const [activeTab, setActiveTab] = useState('statistics');
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedFilter, setSelectedFilter] = useState('all');

  const navigationTabs = [
    { id: 'classes', name: '班級管理', icon: Building },
    { id: 'teachers', name: '教師管理', icon: Users },
    { id: 'students', name: '學生管理', icon: GraduationCap },
    { id: 'statistics', name: '統計資訊', icon: BarChart3 }
  ];

  const teacherNavigationTabs = [
    { id: 'overview', name: '教師概覽', icon: BarChart3 },
    { id: 'homeroom', name: '班主任功能', icon: Users },
    { id: 'subjects', name: '科目管理', icon: BookOpen },
    { id: 'groups', name: '組別Category', icon: Settings }
  ];

  const statistics = [
    { label: '班級總數', value: '24', unit: '班', category: 'class', icon: '🏫' },
    { label: '年級數量', value: '6', unit: '年級', category: 'grade', icon: '📊' },
    { label: '選修班級', value: '4', unit: '班', category: 'elective', icon: '🎯' },
    { label: '年級分布', value: '1, 2, 3... 等6項', unit: '', category: 'distribution', icon: '📈' },
    { label: '教師總數', value: '56', unit: '人', category: 'teacher', icon: '👨‍🏫' },
    { label: '學生總數', value: '360', unit: '人', category: 'student', icon: '👨‍🎓' },
    { label: '選修學生', value: '60', unit: '人', category: 'elective-student', icon: '🎓' }
  ];

  const teacherStats = [
    { label: '總教師數', value: '56', subtitle: '全職教師', icon: User },
    { label: '教學科目', value: '1', subtitle: '主要學科', icon: BookOpen },
    { label: '資深教師', value: '5年以上經驗', subtitle: '', icon: Award }
  ];

  const teachers = [
    { id: 1, name: '陳嘉俊', subject: 'To be assigned', role: '教師', avatar: '陳' },
    { id: 2, name: '陳廣隆', subject: 'Putonghua', role: '班主任', avatar: '陳' },
    { id: 3, name: '陳柏輝', subject: 'English', role: '副班主任', avatar: '陳' },
    { id: 4, name: '陳雕鳳', subject: 'Physical Education', role: '副班主任', avatar: '陳' },
    { id: 5, name: '陳偉光', subject: 'To be assigned', role: '教師', avatar: '陳' },
    { id: 6, name: '鄒志良', subject: 'ICT', role: '班主任', avatar: '鄒' },
    { id: 7, name: '鄒永新', subject: 'Biology', role: '班主任', avatar: '鄒' },
    { id: 8, name: '陳凱怡', subject: 'Design and Applied Technology', role: '班主任', avatar: '陳' },
    { id: 9, name: '鄭振壽', subject: 'Mathematics', role: '班主任', avatar: '鄭' },
    { id: 10, name: '鄭明忠', subject: 'Design and Applied Technology', role: '副班主任', avatar: '鄭' },
    { id: 11, name: '張煥森', subject: 'To be assigned', role: '教師', avatar: '張' },
    { id: 12, name: '蔡美玉', subject: 'Chemistry', role: '副班主任', avatar: '蔡' },
    { id: 13, name: '徐隆堅', subject: 'Mathematics', role: '班主任', avatar: '徐' },
    { id: 14, name: '徐文超', subject: 'To be assigned', role: '教師', avatar: '徐' },
    { id: 15, name: '鍾麗綺', subject: 'Accounting', role: '副班主任', avatar: '鍾' }
  ];

  const classes = [
    { id: 1, code: 'J1A', grade: '中1', letter: 'A' },
    { id: 2, code: 'J1B', grade: '中1', letter: 'B' },
    { id: 3, code: 'J1C', grade: '中1', letter: 'C' },
    { id: 4, code: 'J1D', grade: '中1', letter: 'D' },
    { id: 5, code: 'J2A', grade: '中2', letter: 'A' },
    { id: 6, code: 'J2B', grade: '中2', letter: 'B' },
    { id: 7, code: 'J2C', grade: '中2', letter: 'C' },
    { id: 8, code: 'J2D', grade: '中2', letter: 'D' }
  ];

  const subjectGroups = [
    {
      name: '公民、經濟與社會',
      englishName: 'Civics, Economics & Society',
      teacherCount: 7,
      teachers: [
        { name: '陳嘉俊', status: 'To be assigned', avatar: '陳' },
        { name: '蘇家輝', status: 'To be assigned', avatar: '蘇' },
        { name: '袁建灝', status: 'To be assigned', avatar: '袁' },
        { name: '陳偉光', status: 'To be assigned', avatar: '陳' }
      ]
    }
  ];

  const groupCategories = [
    {
      name: '核心領導組',
      englishName: 'Core Team',
      memberCount: 4,
      members: [
        { name: '徐文超', status: 'To be assigned', avatar: '徐' },
        { name: '陳偉光', status: 'To be assigned', avatar: '陳' },
        { name: '駱紫薇', status: 'To be assigned', avatar: '駱' },
        { name: '施上海', status: 'Life Skills', avatar: '施' }
      ]
    },
    {
      name: '危機管理組',
      englishName: 'Crisis Management Committee',
      memberCount: 7,
      members: [
        { name: '陳偉光', status: 'To be assigned', avatar: '陳' },
        { name: '徐文超', status: 'To be assigned', avatar: '徐' },
        { name: '伍式芬', status: 'To be assigned', avatar: '伍' },
        { name: '施上海', status: 'Life Skills', avatar: '施' },
        { name: '駱紫薇', status: 'To be assigned', avatar: '駱' },
        { name: '范伊雲', status: 'To be assigned', avatar: '范' }
      ]
    }
  ];

  const filterOptions = [
    { value: 'all', label: '全部' },
    { value: 'grade1', label: '一年級' },
    { value: 'grade2', label: '二年級' },
    { value: 'grade3', label: '三年級' },
    { value: 'elective', label: '選修班級' }
  ];

  return (
    <div className="school-timetable-management">
      {/* Header Section */}
      <div className="management-header">
        <div className="header-content">
          <div className="header-icon">
            <Home size={24} />
          </div>
          <div className="header-text">
            <h1 className="main-title">學校時間表管理系統</h1>
            <p className="subtitle">管理班級時間表、教師安排及選修科目</p>
          </div>
        </div>
      </div>

      {/* Navigation Bar */}
      <div className="navigation-bar">
        <button className="back-button" onClick={onBack}>
          <ArrowLeft size={16} />
          返回主頁
        </button>
        
        <div className="nav-tabs">
          {navigationTabs.map(tab => {
            const Icon = tab.icon;
            return (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`nav-tab ${activeTab === tab.id ? 'active' : ''}`}
              >
                <Icon size={18} />
                <span>{tab.name}</span>
              </button>
            );
          })}
        </div>
      </div>

      {/* Main Content */}
      <div className="main-content">
        {activeTab === 'statistics' && (
          <div className="statistics-section">
            <div className="section-header">
              <h2 className="section-title">統計資訊</h2>
            </div>
            
            <div className="statistics-grid">
              {statistics.map((stat, index) => (
                <div key={index} className={`stat-card stat-card-${stat.category}`}>
                  <div className="stat-content">
                    <div className="stat-value">
                      <span className="value-number">{stat.value}</span>
                      {stat.unit && <span className="value-unit">{stat.unit}</span>}
                    </div>
                    <div className="stat-label">{stat.label}</div>
                  </div>
                  <div className="stat-icon">
                    <span className="stat-emoji">{stat.icon}</span>
                  </div>
                </div>
              ))}
            </div>

            {/* Teacher List Section */}
            <div className="teacher-list-section">
              <div className="section-header">
                <h2 className="section-title">教師名單</h2>
              </div>
              <div className="teacher-grid">
                {teachers.map(teacher => (
                  <div key={teacher.id} className="teacher-card">
                    <div className="teacher-avatar">
                      {teacher.avatar}
                    </div>
                    <div className="teacher-info">
                      <div className="teacher-name">{teacher.name}</div>
                      <div className="teacher-role">{teacher.role}</div>
                      <div className="teacher-subject">{teacher.subject}</div>
                    </div>
                    <button className="view-details-btn">查看詳情</button>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}

        {activeTab === 'classes' && (
          <div className="classes-section">
            <div className="section-header">
              <h2 className="section-title">班級管理</h2>
            </div>
            
            <div className="class-grid">
              {classes.map(classItem => (
                <div key={classItem.id} className="class-card">
                  <div className="class-icon">
                    <Building size={20} />
                  </div>
                  <div className="class-info">
                    <div className="class-code">{classItem.code}</div>
                    <div className="class-grade">{classItem.grade}</div>
                    <div className="class-letter">{classItem.letter}</div>
                  </div>
                  <button className="view-timetable-btn">點擊查看時間表</button>
                </div>
              ))}
            </div>
          </div>
        )}

        {activeTab === 'teachers' && (
          <div className="teachers-section">
            <div className="teacher-navigation">
              {teacherNavigationTabs.map(tab => {
                const Icon = tab.icon;
                return (
                  <button
                    key={tab.id}
                    className={`teacher-nav-tab ${activeTab === tab.id ? 'active' : ''}`}
                    onClick={() => setActiveTab(tab.id)}
                  >
                    <Icon size={16} />
                    <span>{tab.name}</span>
                  </button>
                );
              })}
            </div>

            {activeTab === 'overview' && (
              <div className="teacher-overview">
                <div className="teacher-stats-grid">
                  {teacherStats.map((stat, index) => {
                    const Icon = stat.icon;
                    return (
                      <div key={index} className="teacher-stat-card">
                        <div className="teacher-stat-icon">
                          <Icon size={24} />
                        </div>
                        <div className="teacher-stat-content">
                          <div className="teacher-stat-value">{stat.value}</div>
                          <div className="teacher-stat-label">{stat.label}</div>
                          {stat.subtitle && <div className="teacher-stat-subtitle">{stat.subtitle}</div>}
                        </div>
                      </div>
                    );
                  })}
                </div>

                <div className="teacher-list-section">
                  <div className="section-header">
                    <h2 className="section-title">教師名單</h2>
                  </div>
                  <div className="teacher-grid">
                    {teachers.slice(0, 3).map(teacher => (
                      <div key={teacher.id} className="teacher-card">
                        <div className="teacher-avatar">
                          {teacher.avatar}
                        </div>
                        <div className="teacher-info">
                          <div className="teacher-name">{teacher.name}</div>
                          <div className="teacher-role">{teacher.role}</div>
                          <div className="teacher-subject">{teacher.subject}</div>
                        </div>
                        <button className="view-details-btn">查看詳情</button>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            )}

            {activeTab === 'subjects' && (
              <div className="subject-management">
                <div className="section-header">
                  <h2 className="section-title">科目管理</h2>
                  <button className="download-btn">
                    <Download size={16} />
                    下載科目教師名單
                  </button>
                </div>

                {subjectGroups.map((group, index) => (
                  <div key={index} className="subject-group">
                    <div className="subject-group-header">
                      <h3 className="subject-group-title">{group.name}</h3>
                      <span className="subject-group-count">({group.teacherCount} 位教師)</span>
                      <button className="manage-btn">
                        <Settings size={14} />
                        管理
                      </button>
                    </div>
                    <div className="subject-teachers-grid">
                      {group.teachers.map((teacher, teacherIndex) => (
                        <div key={teacherIndex} className="subject-teacher-card">
                          <div className="subject-teacher-avatar">
                            {teacher.avatar}
                          </div>
                          <div className="subject-teacher-info">
                            <div className="subject-teacher-name">{teacher.name}</div>
                            <div className="subject-teacher-status">{teacher.status}</div>
                          </div>
                          <button className="view-details-btn">查看詳情</button>
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            )}

            {activeTab === 'groups' && (
              <div className="group-management">
                <div className="section-header">
                  <h2 className="section-title">組別Category</h2>
                  <button className="download-btn">
                    <Download size={16} />
                    下載組別成員名單
                  </button>
                </div>

                <div className="group-categories">
                  <h3 className="group-category-title">行政及管理 Administration and Management</h3>
                  <div className="group-cards-grid">
                    {groupCategories.map((group, index) => (
                      <div key={index} className="group-card">
                        <div className="group-card-header">
                          <div className="group-card-title">
                            <h4>{group.name}</h4>
                            <span className="group-card-subtitle">{group.englishName}</span>
                            <span className="group-member-count">組別成員 ({group.memberCount}人)</span>
                          </div>
                          <button className="manage-btn">
                            <Settings size={14} />
                            管理
                          </button>
                        </div>
                        <div className="group-members-grid">
                          {group.members.map((member, memberIndex) => (
                            <div key={memberIndex} className="group-member-card">
                              <div className="group-member-avatar">
                                {member.avatar}
                              </div>
                              <div className="group-member-info">
                                <div className="group-member-name">{member.name}</div>
                                <div className="group-member-status">{member.status}</div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            )}
          </div>
        )}

        {activeTab === 'students' && (
          <div className="students-section">
            <div className="section-header">
              <h2 className="section-title">學生管理</h2>
            </div>
            <div className="placeholder-content">
              <p>學生管理功能將在此處顯示</p>
            </div>
          </div>
        )}

        {/* Search and Filter Section */}
        <div className="search-filter-section">
          <div className="search-container">
            <div className="search-input-wrapper">
              <Search className="search-icon" size={18} />
              <input
                type="text"
                placeholder={activeTab === 'teachers' ? "搜尋教師姓名..." : "搜尋班級名稱..."}
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="search-input"
              />
            </div>
          </div>
          
          <div className="filter-container">
            <div className="filter-dropdown">
              <button className="filter-button">
                <Filter size={16} />
                <span>{filterOptions.find(opt => opt.value === selectedFilter)?.label}</span>
                <ChevronDown size={14} />
              </button>
              <div className="filter-options">
                {filterOptions.map(option => (
                  <button
                    key={option.value}
                    onClick={() => setSelectedFilter(option.value)}
                    className={`filter-option ${selectedFilter === option.value ? 'active' : ''}`}
                  >
                    {option.label}
                  </button>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SchoolTimetableManagement;
